import { render, staticRenderFns } from "./ReservoirManagerView.vue?vue&type=template&id=7e891986&scoped=true"
import script from "./ReservoirManagerView.vue?vue&type=script&lang=js"
export * from "./ReservoirManagerView.vue?vue&type=script&lang=js"
import style0 from "./ReservoirManagerView.vue?vue&type=style&index=0&id=7e891986&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e891986",
  null
  
)

export default component.exports